import { useTranslation } from 'react-i18next';
import { Button, Flex, ModalHeader, type ModalHeaderProps } from '@/ui';
import { HEADER_HEIGHT } from '../constants';
import { DuplicateStatus } from './DuplicateStatus';

type Props = ModalHeaderProps & {
  onCancelClick?: () => void;
  onSaveClick: () => void;
};

export const EntryModalHeader = ({
  children,
  onCancelClick,
  onSaveClick,
  ...props
}: Props) => {
  const { t } = useTranslation('entryModal');

  return (
    <ModalHeader
      alignItems="center"
      display="flex"
      flexDir="row"
      gap="2"
      h={HEADER_HEIGHT}
      justifyContent="flex-end"
      px={{ base: 4, md: undefined }}
      {...props}
    >
      <DuplicateStatus />

      <Flex align="center" gap="1">
        {children}
      </Flex>

      <Flex gap="2">
        {onCancelClick && (
          <Button size="sm" variant="secondary" onClick={onCancelClick}>
            {t('cancel')}
          </Button>
        )}
        <Button size="sm" onClick={onSaveClick}>
          {t('done')}
        </Button>
      </Flex>
    </ModalHeader>
  );
};
